import { render, staticRenderFns } from "./Totp.vue?vue&type=template&id=06deab16&"
import script from "./Totp.vue?vue&type=script&lang=ts&"
export * from "./Totp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports